import createReactComponent from '../createReactComponent';
export default createReactComponent('rectangle-filled', 'IconRectangleFilled', [
  [
    'path',
    {
      d: 'M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z',
      fill: 'currentColor',
      key: 'svg-0',
      strokeWidth: '0',
    },
  ],
]);
